// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-ti { padding: 0; }

.dp-ti__loading {
  padding: 20px;
  text-align: center;
  color: #64748b;
  font-size: 12px;
}

.dp-ti__error {
  padding: 10px 12px;
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
  border-radius: 6px;
  font-size: 12px;
}

.dp-ti__msg {
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 8px;
}
.dp-ti__msg--success { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }
.dp-ti__msg--error { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }

/* Sections */
.dp-ti__section {
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 0;
}
.dp-ti__section:last-child { border-bottom: none; }

.dp-ti__section-header {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dp-ti__section-count {
  font-weight: 400;
  font-size: 11px;
  color: #94a3b8;
}

/* Badges */
.dp-ti__badges {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.dp-ti__badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.dp-ti__badge--green { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }
.dp-ti__badge--amber { background: #fffbeb; color: #b45309; border: 1px solid #fde68a; }

/* Fields */
.dp-ti__field {
  margin-bottom: 8px;
}
.dp-ti__field label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
}

.dp-ti__value {
  font-size: 12px;
  color: #1e293b;
}

/* Meta */
.dp-ti__meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 8px;
  font-size: 10px;
  color: #94a3b8;
}

/* Buttons */
.dp-ti__btn {
  cursor: pointer;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
}
.dp-ti__btn--primary {
  width: 100%;
  padding: 7px 12px;
  background: #2563eb;
  color: #fff;
  margin-top: 4px;
}
.dp-ti__btn--primary:hover { background: #1d4ed8; }
.dp-ti__btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }

.dp-ti__btn--small {
  padding: 3px 8px;
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
  flex-shrink: 0;
}
.dp-ti__btn--small:hover { background: #e2e8f0; }

.dp-ti__btn--link {
  background: none;
  color: #2563eb;
  padding: 4px 0;
  font-size: 11px;
}
.dp-ti__btn--link:hover { text-decoration: underline; }

/* Versions */
.dp-ti__versions {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dp-ti__version {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 4px;
}

.dp-ti__version-top {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.dp-ti__version-num {
  font-size: 11px;
  font-weight: 700;
  color: #1e293b;
}

.dp-ti__version-status {
  font-size: 10px;
  font-weight: 600;
}

.dp-ti__version-size {
  font-size: 10px;
  color: #94a3b8;
  margin-left: auto;
}

.dp-ti__version-bottom {
  width: 100%;
  display: flex;
  gap: 6px;
  font-size: 10px;
  color: #94a3b8;
}

.dp-ti__version-notes {
  color: #64748b;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Settings */
.dp-ti__setting {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f1f5f9;
}
.dp-ti__setting:last-child { border-bottom: none; }

.dp-ti__setting-label {
  font-size: 11px;
  color: #475569;
}

.dp-ti__setting-value {
  font-size: 11px;
  color: #1e293b;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/TemplateInfo.css"],"names":[],"mappings":"AAAA,SAAS,UAAU,EAAE;;AAErB;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACvF,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAErF,aAAa;AACb;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACvF,uBAAuB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAEvF,WAAW;AACX;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA,6BAA6B,mBAAmB,EAAE;AAClD,gCAAgC,YAAY,EAAE,mBAAmB,EAAE;;AAEnE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA,0BAA0B,0BAA0B,EAAE;;AAEtD,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;AACA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".dp-ti { padding: 0; }\n\n.dp-ti__loading {\n  padding: 20px;\n  text-align: center;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.dp-ti__error {\n  padding: 10px 12px;\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.dp-ti__msg {\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n.dp-ti__msg--success { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }\n.dp-ti__msg--error { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }\n\n/* Sections */\n.dp-ti__section {\n  border-bottom: 1px solid #e2e8f0;\n  padding: 10px 0;\n}\n.dp-ti__section:last-child { border-bottom: none; }\n\n.dp-ti__section-header {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dp-ti__section-count {\n  font-weight: 400;\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n/* Badges */\n.dp-ti__badges {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n}\n\n.dp-ti__badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n.dp-ti__badge--green { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }\n.dp-ti__badge--amber { background: #fffbeb; color: #b45309; border: 1px solid #fde68a; }\n\n/* Fields */\n.dp-ti__field {\n  margin-bottom: 8px;\n}\n.dp-ti__field label {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 3px;\n}\n\n.dp-ti__value {\n  font-size: 12px;\n  color: #1e293b;\n}\n\n/* Meta */\n.dp-ti__meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 8px;\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n/* Buttons */\n.dp-ti__btn {\n  cursor: pointer;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n}\n.dp-ti__btn--primary {\n  width: 100%;\n  padding: 7px 12px;\n  background: #2563eb;\n  color: #fff;\n  margin-top: 4px;\n}\n.dp-ti__btn--primary:hover { background: #1d4ed8; }\n.dp-ti__btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.dp-ti__btn--small {\n  padding: 3px 8px;\n  background: #f1f5f9;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n.dp-ti__btn--small:hover { background: #e2e8f0; }\n\n.dp-ti__btn--link {\n  background: none;\n  color: #2563eb;\n  padding: 4px 0;\n  font-size: 11px;\n}\n.dp-ti__btn--link:hover { text-decoration: underline; }\n\n/* Versions */\n.dp-ti__versions {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dp-ti__version {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 8px;\n  background: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 4px;\n}\n\n.dp-ti__version-top {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.dp-ti__version-num {\n  font-size: 11px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.dp-ti__version-status {\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.dp-ti__version-size {\n  font-size: 10px;\n  color: #94a3b8;\n  margin-left: auto;\n}\n\n.dp-ti__version-bottom {\n  width: 100%;\n  display: flex;\n  gap: 6px;\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.dp-ti__version-notes {\n  color: #64748b;\n  font-style: italic;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Settings */\n.dp-ti__setting {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n.dp-ti__setting:last-child { border-bottom: none; }\n\n.dp-ti__setting-label {\n  font-size: 11px;\n  color: #475569;\n}\n\n.dp-ti__setting-value {\n  font-size: 11px;\n  color: #1e293b;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
